import React from "react";
import Img from "../static/Group53.png";

const CardsGarantiasNR10 = () => {
  return (
    <div className="lg:text-2xl text-base mb-7 mt-7 lg:px-16 p-4">
      <div className="flex justify-around flex-wrap items-center mb-5">
        {/* Imagem com carregamento preguiçoso para otimizar desempenho */}
        <img 
          src={Img} 
          alt="Certificado de conformidade com a norma NR-10" 
          className="w-full lg:w-auto lg:max-w-md" 
          loading="lazy" 
          width="600" // Defina largura para evitar CLS
          height="400" // Defina altura para evitar CLS
        />
        <div className="lg:w-2/6 w-full text-blue-800 mt-4 lg:mt-0 text-center lg:text-left">
          <h1 className="lg:text-6xl text-4xl mb-3">NR-10</h1>
          <p className="text-2xl">
            A empresa cumpre padrões de segurança específicos para proteger os
            trabalhadores contra riscos elétricos durante suas atividades.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardsGarantiasNR10;
